import styled from "styled-components"
import {Row} from "react-bootstrap"

import media from "@irati/ui/src/global/media"
import {Body} from "@irati/ui/src/Typography"

export const StyledDiv = styled.div`
  margin: 20px 0;
`
export const StyledRow = styled(Row)`
  display: flex;
  align-items: center;
`
export const LogoWrapper = styled.div`
  text-align: center;
  float: left;
   ${media.tablet`
      padding-top: 0;
  `}
`

export const MobileQty = styled(Body)`
  display: none;
  text-align: right;

  ${media.tablet`
    display: block;
  `}
`
